import { _js } from '@ifixit/localize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { ButtonGroup, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { noteTypes } from '@ifixit/wiki-components/wiki-note';

const headings = {
   note: _js('Note'),
   tip: _js('Tip'),
   important: _js('Important'),
   warning: _js('Warning'),
   caution: _js('Caution'),
};

const NoteToggleButton = () => {
   const { editor } = useEditorContext();
   const targetNoteType = 'note';
   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleNote(targetNoteType).run()}
         isActive={editor.isActive('note')}
         isDisabled={!editor.can().toggleNote(targetNoteType)}
         icon={<FontAwesomeIcon icon={faCircleInfo} />}
         title={_js('Insert a note')}
      />
   );
};

export function NoteDropdown() {
   return (
      <ButtonGroup size="sm" isAttached variant="outline">
         <NoteToggleButton />
         <NoteDropdownMenu />
      </ButtonGroup>
   );
}

function NoteDropdownMenu() {
   const { editor } = useEditorContext();

   return (
      <Menu>
         <MenuButton as={TiptapButton} icon={<FontAwesomeIcon icon={faChevronDown} />} />
         <MenuList>
            {noteTypes.map(type => {
               const noteUpdateHandler = () => editor.chain().focus().setNoteType(type).run();
               const noteStartHandler = () => editor.chain().focus().toggleNote(type).run();
               const onClickHandler = editor.isActive('note')
                  ? noteUpdateHandler
                  : noteStartHandler;
               return (
                  <MenuItem key={type} onClick={onClickHandler}>
                     {headings[type]}
                  </MenuItem>
               );
            })}
         </MenuList>
      </Menu>
   );
}
